//@flow
import React, {useState, useEffect} from 'react';
import {makeStyles, TextField} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {useTrainBotActions} from '../../hooks';
import {useToastActions} from '../../../toast-alert/utils';
import type {StoreChatbot} from '../../../entities';
import {colors} from '../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  textareaContainer: {
    marginBottom: '1rem',
  },
  textarea: {
    width: '100%',
    '& .MuiInputBase-root': {
      fontSize: '0.9rem',
      lineHeight: 1.6,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: colors.grey200,
      },
      '&:hover fieldset': {
        borderColor: colors.grey300,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.primary,
        borderWidth: '2px',
      },
    },
  },
  sectionFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1rem',
  },
  submitButton: {
    padding: '0.5rem 1rem',
    maxWidth: '200px',
  },
}));

type Props = {
  chatBot: StoreChatbot,
  onSaveSuccess: () => void,
  initialText: string,
};

const TrainingTabText = React.memo(function TrainingTabText(props: Props) {
  const classes = useStyles();
  const {showToast} = useToastActions();
  const {trainBot, loading} = useTrainBotActions();

  const [text, setText] = useState('');

  useEffect(() => {
    setText(props.initialText);
  }, [props.initialText]);

  const handleTrain = async () => {
    if (!props.chatBot?.id) return;

    try {
      if (!text.trim()) {
        showToast({
          message: 'Por favor ingresa un texto para entrenar el bot',
          title: 'Texto requerido',
          type: 'warning',
          duration: 3000,
        });
        return;
      }

      await trainBot(props.chatBot.id, {
        trainingType: 'TEXT',
        text,
      });

      showToast({
        message: 'Entrenamiento con texto iniciado correctamente',
        title: 'Entrenamiento iniciado',
        type: 'success',
        duration: 3000,
      });

      props.onSaveSuccess();
    } catch (error) {
      const errorMessage =
        error?.message || 'Error desconocido durante el entrenamiento';
      showToast({
        message: errorMessage,
        title: 'Error en el entrenamiento',
        type: 'error',
        duration: 5000,
      });
    }
  };

  return (
    <>
      <div className={classes.textareaContainer}>
        <TextField
          multiline
          rows={15}
          variant="outlined"
          placeholder="Escribe o pega el texto para entrenar el bot..."
          value={text}
          onChange={e => setText(e.target.value)}
          className={classes.textarea}
          fullWidth
        />
      </div>
      <div className={classes.sectionFooter}>
        <CustomButton
          variant="contained"
          color="primary"
          className={classes.submitButton}
          onClick={handleTrain}
          disabled={loading}
          fullWidth
        >
          {loading ? 'Cargando...' : 'Guardar'}
        </CustomButton>
      </div>
    </>
  );
});

export default TrainingTabText;
